import { handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
const type = 'alert.voiceMessageTypeLayout';
const VoiceMessageTypeLayout = (props) => {
    var _a, _b, _c, _d;
    const upLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    return (React.createElement(Box, { sx: {
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            alignItems: { xs: 'flex-start', lg: 'center' },
        } },
        ((_a = props.childProps) === null || _a === void 0 ? void 0 : _a[0]) && (React.createElement(Box, null,
            React.createElement(WidgetComponent, Object.assign({}, (_b = props.childProps) === null || _b === void 0 ? void 0 : _b[0])))),
        ((_c = props.childProps) === null || _c === void 0 ? void 0 : _c[1]) && (React.createElement(Box, { sx: { marginLeft: upLgScreen ? 'auto' : 0 } },
            React.createElement(WidgetComponent, Object.assign({}, (_d = props.childProps) === null || _d === void 0 ? void 0 : _d[1]))))));
};
export const widgetVoiceMessageTypeLayout = {
    type,
    update: (props) => handleWidgetUpdate(props),
    childConfigs: (config) => config.children,
    component: VoiceMessageTypeLayout,
};
